var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "h-screen flex w-full bg-img vx-row no-gutter items-center justify-center",
      style: { "background-image": "url(" + _vm.imagenFondo + ") !important" },
      attrs: { id: "page-login" }
    },
    [
      _vm.ingresoLogo
        ? _c("img", {
            style: _vm.logoStyle,
            attrs: { src: _vm.ingresoLogo.imagen, id: "logo" }
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4"
        },
        [
          _c("vx-card", [
            _c(
              "div",
              {
                staticClass: "full-page-bg-color",
                attrs: { slot: "no-body" },
                slot: "no-body"
              },
              [
                _c(
                  "div",
                  { staticClass: "row no-gutter justify-center items-center" },
                  [
                    _c("div", { staticClass: "col-lg-6 col-md-12" }, [
                      _vm.isImage
                        ? _c("img", {
                            staticClass: "mx-auto",
                            attrs: { src: _vm.imagenIngreso, alt: "login" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isImage
                        ? _c("img", {
                            staticClass: "mx-auto",
                            attrs: {
                              src: require("@/assets/images/pages/login.png"),
                              alt: "login"
                            }
                          })
                        : _vm._e()
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-lg-6 col-md-12 d-theme-dark-bg" },
                      [
                        _c("div", { staticClass: "p-8 login-tabs-container" }, [
                          !_vm.forgotPassword && !_vm.fase2fa
                            ? _c(
                                "div",
                                { staticClass: "vx-card__title mb-10" },
                                [
                                  _c("h4", {
                                    staticClass: "mb-4",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.tituloIngreso)
                                    }
                                  }),
                                  _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.textoHtml)
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm.forgotPassword
                            ? _c(
                                "div",
                                { staticClass: "vx-card__title mb-10" },
                                [
                                  _c("h4", { staticClass: "mb-4" }, [
                                    _vm._v("Resetear Contraseña")
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      " Ingresa tu correo electrónico y te enviaremos las instrucciones para obtener una nueva contraseña "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm.fase2fa
                            ? _c(
                                "div",
                                { staticClass: "login-tabs-container" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "vx-card__title mb-6" },
                                    [
                                      _c("h4", { staticClass: "mb-4" }, [
                                        _vm._v("Verificación en dos pasos")
                                      ]),
                                      _vm.metodo2fa === "EMAIL"
                                        ? _c("p", [
                                            _vm._v(
                                              " Ingresa el código que enviamos a "
                                            ),
                                            _c("b", [
                                              _vm._v(_vm._s(_vm.correoOfuscado))
                                            ])
                                          ])
                                        : _vm.metodo2fa === "TOTP"
                                        ? _c("p", [
                                            _vm._v(
                                              " Ingresa el código de tu aplicación autenticadora "
                                            )
                                          ])
                                        : _c("p", [
                                            _vm._v(
                                              " Ingresa el código de verificación "
                                            )
                                          ])
                                    ]
                                  ),
                                  _c("otp-input", {
                                    ref: "otpInput",
                                    attrs: {
                                      disabled: _vm.verificando,
                                      "has-error": _vm.otpError
                                    },
                                    on: {
                                      complete: function($event) {
                                        return _vm.verificar2fa()
                                      }
                                    },
                                    model: {
                                      value: _vm.otp,
                                      callback: function($$v) {
                                        _vm.otp = $$v
                                      },
                                      expression: "otp"
                                    }
                                  }),
                                  _c(
                                    "vs-button",
                                    {
                                      staticClass: "w-full mt-8 btn-ingresar",
                                      attrs: {
                                        disabled:
                                          _vm.otp.length < _vm.otpLength ||
                                          _vm.verificando,
                                        "data-cy": "verify-otp"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.verificar2fa()
                                        }
                                      }
                                    },
                                    [_vm._v(" Verificar ")]
                                  ),
                                  _vm.metodo2fa === "EMAIL"
                                    ? _c(
                                        "div",
                                        { staticClass: "text-center mt-5" },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                variant: "flat-primary",
                                                disabled:
                                                  _vm.reenviando ||
                                                  _vm.cooldownRestante > 0,
                                                "data-cy": "resend-otp"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.reenviarCodigo()
                                                }
                                              }
                                            },
                                            [
                                              _vm.reenviando
                                                ? _c("b-spinner", {
                                                    staticClass: "mr-1",
                                                    attrs: { small: "" }
                                                  })
                                                : _vm._e(),
                                              _vm.reenviando
                                                ? _c("span", [
                                                    _vm._v("Reenviando...")
                                                  ])
                                                : _vm.cooldownRestante > 0
                                                ? _c("span", [
                                                    _vm._v(
                                                      "Reenviar código en " +
                                                        _vm._s(
                                                          _vm.cooldownRestante
                                                        ) +
                                                        "s"
                                                    )
                                                  ])
                                                : _c("span", [
                                                    _vm._v("Reenviar código")
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    { staticClass: "text-center mt-3" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant: "flat-secondary",
                                            "data-cy": "back-from-otp"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.cancelar2fa()
                                            }
                                          }
                                        },
                                        [_vm._v(" Volver ")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.forgotPassword && !_vm.fase2fa
                            ? _c(
                                "form",
                                {
                                  ref: "form",
                                  attrs: { "data-vv-scope": "form" },
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                      return _vm.attemptSignIn()
                                    }
                                  }
                                },
                                [
                                  _c("vs-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|email",
                                        expression: "'required|email'"
                                      }
                                    ],
                                    staticClass: "w-full",
                                    attrs: {
                                      name: "correo",
                                      "data-cy": "mail",
                                      "icon-no-border": "",
                                      icon: "icon icon-user",
                                      "icon-pack": "feather",
                                      "label-placeholder":
                                        _vm.nombreCampoUsuario,
                                      danger: _vm.errors.has("form.correo"),
                                      "danger-text": _vm.errors.first(
                                        "form.correo"
                                      )
                                    },
                                    nativeOn: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.attemptSignIn()
                                      }
                                    },
                                    model: {
                                      value: _vm.correo,
                                      callback: function($$v) {
                                        _vm.correo = $$v
                                      },
                                      expression: "correo"
                                    }
                                  }),
                                  _c("vs-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "w-full mt-8",
                                    attrs: {
                                      type: "password",
                                      name: "clave",
                                      "data-cy": "password",
                                      "icon-no-border": "",
                                      icon: "icon icon-lock",
                                      "icon-pack": "feather",
                                      "label-placeholder": _vm.nombreCampoClave,
                                      required: "",
                                      danger: _vm.errors.has("form.clave"),
                                      "danger-text": _vm.errors.first(
                                        "form.clave"
                                      )
                                    },
                                    nativeOn: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.attemptSignIn()
                                      }
                                    },
                                    model: {
                                      value: _vm.clave,
                                      callback: function($$v) {
                                        _vm.clave = $$v
                                      },
                                      expression: "clave"
                                    }
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-wrap justify-between my-5"
                                    },
                                    [
                                      _vm.product !== "ed"
                                        ? _c(
                                            "vs-checkbox",
                                            {
                                              staticClass: "mb-3",
                                              model: {
                                                value: _vm.recordar,
                                                callback: function($$v) {
                                                  _vm.recordar = $$v
                                                },
                                                expression: "recordar"
                                              }
                                            },
                                            [_vm._v(" Recordar mi usuario ")]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "b-button",
                                        {
                                          attrs: { variant: "flat-secondary" },
                                          on: {
                                            click: _vm.iForgotThePassToggle
                                          }
                                        },
                                        [_vm._v(" ¿Olvidaste tu contraseña? ")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.botonRegistroProveedor &&
                                  _vm.product !== "ed"
                                    ? _c(
                                        "vs-button",
                                        { attrs: { type: "border" } },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.nombreBotonRegistroProveedores
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "vs-button",
                                    {
                                      staticClass:
                                        "float-right btn-ingresar mb-10",
                                      staticStyle: { "margin-top": "20px" },
                                      attrs: { "data-cy": "get-in" },
                                      on: {
                                        click: function($event) {
                                          return _vm.attemptSignIn()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.nombreBotonIngreso) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _vm.botonClaveUnica || _vm.botonGoogle
                                    ? _c(
                                        "div",
                                        { attrs: { id: "clave-unica" } },
                                        [_c("vs-divider", [_vm._v("O")])],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.botonClaveUnica
                                    ? _c(
                                        "div",
                                        { attrs: { id: "clave-unica" } },
                                        [
                                          _vm._v(
                                            " También puedes ingresar con "
                                          ),
                                          _c("B", [_vm._v("Clave Única")]),
                                          _vm._v(" del "),
                                          _c("B", [_vm._v("Registro Civil")]),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-wrap mt-5 justify-center"
                                            },
                                            [
                                              _c("button-clave-unica", {
                                                attrs: {
                                                  size: "md",
                                                  "full-width": ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.redirectToClaveUnica()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.botonGoogle
                                    ? _c(
                                        "div",
                                        { attrs: { id: "federate-auth" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-wrap mt-5 federate-auth",
                                              on: {
                                                click: function($event) {
                                                  return _vm.redirectToEntity(
                                                    "google"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "google-btn btn btn-default",
                                                  attrs: { id: "customBtn" }
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass: "icon-google"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "buttonText"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Ingresa con Google"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.forgotPassword
                            ? _c(
                                "div",
                                { staticClass: "login-tabs-container" },
                                [
                                  _c("forgot-password", {
                                    on: { close: _vm.iForgotThePassToggle }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }